import React from 'react';

import { ClickableIcon } from '../../ClickableIcon';
import { IconArrowLeft, IconArrowRight } from '../../../icons';
import { Text } from '../../Text';
import { HStack } from '../../Stack';
import { cn } from '../../../lib/css/className/className';
import { TestProps } from '../../../internal/types/testTypes';

import './AlertLineCounter.css';
import { i18n } from './AlertLineCounter.i18n';

const cls = cn('AlertLineCounter');

export interface AlertLineCounterProps extends TestProps {
    /** Количество слайдов */
    slideCount: number;
    /** index выбранного слайда */
    currentSlideIndex: number;
    /** Обработчик клика по левой кнопке */
    onPrevious: () => void;
    /** Обработчик клика по правой кнопке */
    onNext: () => void;
}

export const AlertLineCounter = function AlertLineCounter(props: AlertLineCounterProps) {
    const { 'data-testid': dataTestId = 'AlertLineCounter', slideCount, currentSlideIndex, onPrevious, onNext } = props;

    return (
        <HStack gap="current-geometry" className={cls('')} data-testid={dataTestId}>
            <ClickableIcon onClick={onPrevious} color="current" data-testid={`${dataTestId}.Previous`}>
                <IconArrowLeft size="20" />
            </ClickableIcon>
            <Text size="s" color={'current'}>
                {i18n('{currentSlideIndex} из {slideCount}', {
                    currentSlideIndex: String(currentSlideIndex),
                    slideCount: String(slideCount),
                })}
            </Text>
            <ClickableIcon onClick={onNext} color="current" data-testid={`${dataTestId}.Next`}>
                <IconArrowRight size="20" />
            </ClickableIcon>
        </HStack>
    );
};
